import MainTestScenario from './MainTestScenario';
import { constants } from '../../../../misc/helpers';

export default class MainTestScenarioStep2 {
	constructor(private mainScenario: MainTestScenario, private onDone: (index: number, aarReady2: boolean) => void, public showFailedAar: () => void) {
	}

	start() {
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});

			this.step1ShowBleedingControlKitAudio();
	}

	private step1ShowBleedingControlKitAudio() {
		//this.step1ShowBleedingControlKit();//Need to double check this placement to match practice scenario audio
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		if (this.mainScenario.skipBCK === true) {
			this.step2PPESelected();
		}
		else {
			this.mainScenario.playSound('Step-2', '1', () => {
				this.step1ShowBleedingControlKit();
			});
		}
	}

	private step1ShowBleedingControlKit() {
		var context = this;
			context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BleedingControlKit, {
				onSelectionChanged: (index: number) => {
					if(!context.mainScenario.gameManager || !context.mainScenario.gameManager.UiManager) {
						return;
					}
					if(index === 2) {
						context.step2PPESelected();
					}
					else if(index === 1) {
						context.onDone(-3, false);
					}
					else if(index === 0) {
						context.onDone(-2, false);
					}
					else {
						context.onDone(index, false);
					}
				}
			});
	}

	private step2PPESelected() {
		var context = this;

		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BleedingControlKit, {
			disablePPEButton: true
		});
		setTimeout(() => {
			if(!context.mainScenario.gameManager || !context.mainScenario.gameManager.UiManager) {
				return;
			}
			context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
		}, 0);
		context.mainScenario.playSequence('PutOnPPE', null, () => {
			if(this.mainScenario.stepsOrder2 === true) {
				context.mainScenario.aarWearPPE = true;
			}
			else {
				context.mainScenario.aarWearPPE = false;
			}
			context.onDone(-1, true)
		});
		context.mainScenario.playSequence('VictimPlayLips');

		this.mainScenario.playSound('Step-2', '2', () => {//need to check this to match practice scenario Audio
			context.mainScenario.playSequence('VictimStopLips');

		});
	}
	// private step2PPENotSelected() {
	// 	var context = this;
	// 	context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
	// 	this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step1ShowBleedingControlKit());
	// }
}